/**
 * FormError — inline error message styled per ui-guidelines.md §7.
 * Brick color, never red-on-red fill.
 */

interface FormErrorProps {
  message: string | null | undefined;
}

export function FormError({ message }: FormErrorProps) {
  if (!message) return null;
  return (
    <p role="alert" className="border-l-2 border-starz-brick pl-3 text-sm text-starz-brick">
      {message}
    </p>
  );
}
